import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../../../components/Forms/FormCreator";
import Accordion from "../../../../components/Accordion/Accordion";
import Buttons from "../../../../components/ui/button/Buttons";
import { MembershipSubscriptionData } from "./MembershipSubscription.data";
import { filterApplicationTerms, getOverseasSubscriptionPrice, getReinstatementSubscriptionPrice, getSubscriptionPrice, getSubsidiaryTerms, hideAndShowMemberSubscription, hideAndShowReinstatementFee, termValueMap } from "./Utils/setFieldParameter";
import { useLazyGetCorporateMembershipPricingQuery, useLazyGetGstRateQuery, useLazyGetSubsidiaryCompanyInfoByMemberIdQuery, useUpdateCorporateMembershipSubscriptionByAdminMutation } from "../../../../app/services/CorporateMembershipTaskList/corporateMembershipTaskListApi";
import { useParams } from "react-router-dom";
import { decryptAESID } from "../../../../utils/Encryption";
import SwalAlert from "../../../../services/swalService/SwalService";
import moment from "moment";

const MembershipSubscriptionForm = ({ subscriptionType, membershipData, dropdownData, onSubscriptionUpdated, isViewOnly, isAppLocked}) => {
  const membershipSubscriptionRef = useRef();
  const { id } = useParams();
  const editID = id ? decryptAESID(id, false) : 0
  const [formData, setFormData] = useState(MembershipSubscriptionData);
  const [membershipPrice, setMembershipPrice] = useState(null);
  const [overseasCompanyPrice, setOverseasCompanyPrice] = useState(null);
  const [reinstatementFee, setReinstatementFee] = useState(null);
  const { error, success } = SwalAlert();
  const [getCorporateMembershipPricing, { data: membershipPricingData },] = useLazyGetCorporateMembershipPricingQuery();
  const [getSubsidiaryCompanyInfoByMemberId, { data: SubsidiaryCompanyInfo },] = useLazyGetSubsidiaryCompanyInfoByMemberIdQuery();
  const [updateCorporateMembershipSubscription, { data: updateCorporateMembershipSubscriptionData, isLoading: updateCorporateMembershipSubscriptionIsLoading, isFetching: updateCorporateMembershipSubscriptionIsFetching, },] = useUpdateCorporateMembershipSubscriptionByAdminMutation();
  const [getGstRate, { data: getGstRateData }] = useLazyGetGstRateQuery();

  useEffect(() => {
    getCorporateMembershipPricing();
    getGstRate();
  }, []);

  useEffect(() => {
    let newFormData = { ...formData }
    const subscriptionId = subscriptionType || null;
    newFormData = hideAndShowReinstatementFee(newFormData, subscriptionId);
    if (membershipData?.linkedMemberId > 0) {
      getSubsidiaryCompanyInfoByMemberId(membershipData?.linkedMemberId)
        .unwrap()
        .then((res) => {
          const sDate = res?.subscriptionStartDate;
          const eDate = res?.subscriptionEndDate;
          const childEnd = membershipData?.subscriptionEndDate;
          if (sDate && eDate) {
            const validTerms = getSubsidiaryTerms(sDate, eDate, childEnd);
            const newForm = {
              ...newFormData,
              formFields: newFormData.formFields.map((field) => {
                if (field.id === "applicationTerm") {
                  return { ...field, fieldSetting: { ...field.fieldSetting, options: validTerms.map((t) => ({ label: t, value: termValueMap[t], })), }, };
                }
                if (membershipData?.applicationTypeId === 2 && field.id === "linkedMember") {
                  return { ...field, fieldSetting: { ...field.fieldSetting, isDisable: false, }, validation: [{ type: "require" }], };
                }
                return field;
              }
              ),
              initialState: { ...newFormData.initialState, linkSubDate: `${moment(sDate).format("DD-MM-YYYY")} - ${moment(eDate).format("DD-MM-YYYY")}` },
            };
            setFormData(newForm);
          }
        });
    }

    setFormData(newFormData);
  }, [membershipData]);

  useEffect(() => {
    if (!updateCorporateMembershipSubscriptionIsLoading && updateCorporateMembershipSubscriptionData) {
      if (updateCorporateMembershipSubscriptionData?.keyId > 0) {
        success("Membership Subscription updated successfully.")
        if (onSubscriptionUpdated) {
          onSubscriptionUpdated();
        }
      }
    }
  }, [updateCorporateMembershipSubscriptionIsLoading, updateCorporateMembershipSubscriptionData]);

  const handleFormFieldChange = (dataField, value) => {
    let updatedForm = { ...formData };
    if (dataField === "applicationType") {
      updatedForm = hideAndShowMemberSubscription(updatedForm, value);
      updatedForm.initialState = {
        ...updatedForm.initialState,
        applicationTerm: value?.value == 3 ? 2 : null,
        linkSubDate: null
      };
      updatedForm = {
        ...updatedForm,
        formFields: updatedForm?.formFields.map((field) =>
          field.id === "applicationTerm" ? {
            ...field,
            fieldSetting: { ...field.fieldSetting, isDisable: value?.value == 3 ? true : false },
          } : field
        )
      }
    }
    const newState = {
      ...updatedForm.initialState,
      [dataField]: value,
    };
    const selectedApplicationType = newState.applicationType?.value || newState.applicationType;
    const selectedApplicationTerm = newState.applicationTerm?.value || newState.applicationTerm;

    if (dataField === "linkedMember") {
      const clearedForm = {
        ...updatedForm,
        formFields: updatedForm.formFields.map((field) =>
          field.id === "applicationTerm"
            ? {
              ...field,
              fieldSetting: {
                ...field.fieldSetting,
                options: [],
              },
              validationRules: field?.validationRules || [],
            }
            : field
        ),
        initialState: {
          ...updatedForm.initialState,
          ...newState,
          applicationTerm: null,
          linkSubDate: null,
        },
      };
      setFormData(clearedForm);

      getSubsidiaryCompanyInfoByMemberId(value?.value || value)
        .unwrap()
        .then((res) => {
          const sDate = res?.subscriptionStartDate;
          const eDate = res?.subscriptionEndDate;
          const childEnd = membershipData?.subscriptionEndDate;
          if (!sDate || !eDate) return;
          const validTerms = getSubsidiaryTerms(sDate, eDate, childEnd);
          const newForm = {
            ...clearedForm,
            formFields: clearedForm.formFields.map((field) =>
              field.id === "applicationTerm"
                ? {
                  ...field,
                  fieldSetting: {
                    ...field.fieldSetting,
                    options: validTerms.map((t) => ({
                      label: t,
                      value: termValueMap[t],
                    })),
                  },
                  validationRules: field?.validationRules || [],
                }
                : field
            ),
            initialState: {
              ...clearedForm.initialState,
              linkSubDate: `${moment(sDate).format("DD-MM-YYYY")} - ${moment(eDate).format("DD-MM-YYYY")}`,
            },
          };
          setFormData(newForm);
        });
      return;
    }

    if (dataField === "applicationType") {
      const allTerms = dropdownData?.filter((x) => x.dropdownName === "Application Terms") || [];
      const filteredTerms = filterApplicationTerms(allTerms, value?.label);
      updatedForm.formFields = updatedForm.formFields.map((field) =>
        field.id === "applicationTerm" ? {
          ...field,
          fieldSetting: { ...field.fieldSetting, options: filteredTerms.map((t) => ({ label: t.name, value: t.id, })), },
        } : field
      );
    }
    if (membershipPricingData) {
      const calculatedPrice = getSubscriptionPrice(membershipPricingData, selectedApplicationType, selectedApplicationTerm);
      setMembershipPrice(calculatedPrice ?? null);
    }
    if (membershipPricingData && dataField === "overseasCompany") {
      const calculatedPrice = getOverseasSubscriptionPrice(membershipPricingData, value);
      setOverseasCompanyPrice(calculatedPrice ?? null);
    }
    if (membershipPricingData && dataField === "reinstatementfee") {
      const calculatedPrice = getReinstatementSubscriptionPrice(membershipPricingData, value);
      setReinstatementFee(calculatedPrice ?? null);
    }
    setFormData((prev) => ({ ...prev, ...updatedForm, initialState: newState, }));
  };

  const paymentHistoryUpdate = async () => {
    const data = membershipSubscriptionRef?.current?.getFormData();
    if (!data) {
      error("Please fill in all mandatory fields to continue.", "")
      return;
    }
    let membershipFee = membershipPrice || null;
    let corporatememberId = editID;
    let GSTRate = getGstRateData?.gstRate;
    if (getGstRateData === null) {
      const response = await getGstRate()
      GSTRate = response?.data?.gstRate;
    }

    const request = {
      SGBCCorporateMemberId: corporatememberId,
      MembershipPaymentTypeId: data?.subscriptionType?.value || data?.subscriptionType,
      ApplicationTypeId: data?.applicationType?.value || data?.applicationType,
      LinkedMemberId: data?.linkedMember?.value || data?.linkedMember,
      ApplicationTermId: data?.applicationTerm?.value || data?.applicationTerm,
      IsOverseasCompany: data?.overseasCompany === "yes" ? true : false,
      IsReinstatement: data?.reinstatementfee === "yes" ? true : false,
      SubTotalAmount: membershipFee || null,
      OverseasCompanyAmount: overseasCompanyPrice || null,
      ReinstatementAmount: reinstatementFee || null,
      GSTAmount: (membershipFee * (GSTRate / 100)) || null,
      OverSeasGSTAmount: (overseasCompanyPrice * (GSTRate / 100)) || null,
      ReinstatementGSTAmount: (reinstatementFee * (GSTRate / 100)) || null,
      GSTRate: GSTRate || null,
      TotalAmount: (membershipFee + membershipFee * (GSTRate / 100)) || null,
      NetTotal: (membershipFee + membershipFee * (GSTRate / 100)) || null,
    };
    updateCorporateMembershipSubscription(request)
  };

  useEffect(() => {
    const applicationType = membershipSubscriptionRef?.current?.getFieldValue("applicationType");
    if (applicationType == 2) {
      setFormData((prev) => ({
        ...prev,
        formFields: prev.formFields.map((field) => field.id === "linkedMember" ? {
          ...field,
          fieldSetting: { ...field.fieldSetting, isDisable: false, }, validation: [{ type: "require" },],
        } : field),
      }));
    }
    else {
      setFormData((prev) => ({
        ...prev,formFields: prev.formFields.map((field) => {
          if (field.id === "linkedMember") {
            return {...field,fieldSetting: {...field.fieldSetting,isDisable: true,},validation: [],};
          }
          if (field.id === "applicationTerm") {
            return {...field,fieldSetting: {...field.fieldSetting,isDisable: applicationType == 3 ? true : false},};
          }
          return field;
        }),
      }));
    }

  }, [getGstRateData]);

  return (
    <Accordion
      title="Membership Subscription"
      button={false}
      accordion={false}
    >
      <div className="row">
        <FormCreator
          ref={membershipSubscriptionRef}
          {...formData}
          onFormFieldValueChange={handleFormFieldChange}
        />
      </div>
      <div className="btn-right-side">
        <Buttons
          buttonText="Save"
          buttonTypeClassName="success-btn"
          onClick={paymentHistoryUpdate}
          isDisable={isViewOnly || isAppLocked}
        />
      </div>
    </Accordion>
  );
};
export default MembershipSubscriptionForm;
